<template>
  <div class="container">
    <div class="main-banner-top">
      <!-- <BannerOpacity> -->


      <div class="old-clients">

        <!--
        <div class="modal-content" style="max-width: 800px; margin: 0 auto; padding: 1rem; font-size: 1.2rem; color: red; font-weight: 700;">
          <p>Uwaga! W dniach 25.11 i 26.11 (wtorek i środa) z powodu inwentaryzacji, zamówienia nie będą realizowane!</p>
          <p>Zamówienia złożone w poniedziałek (24.11.2025) po godzinie 13:00 zostaną zrealizowane w czwartek (27.11.2025).</p>
          <p>Przepraszamy za utrudnienia.</p>
        </div>

        -->



        <!--
        <div class="modal-content" style="max-width: 800px; margin: 0 auto; padding: 1rem; font-size: 1.2rem; color: red; font-weight: 700;">
          <p>W piątek (20.02.2026) nasza hurtownia będzie nieczynna.</p>
          <p>Zamówienia internetowe złożone w czwartek do godziny 12:30 dostarczymy w czwartek 19.02.2026.</p>
          <p>Zamówienia internetowe złożone w czwartek, po godzinie 12:30 dostarczymy w poniedziałek 23.02.2026</p>
          <p>Przepraszamy za niedogodności. </p>
        </div>
        -->

        <!--
        <div class="modal-content" style="max-width: 800px; margin: 0 auto; padding: 1rem; font-size: 1.2rem; color: red; font-weight: 700;">
          <p>Drodzy klienci w związku z planowanymi pracami modernizacyjnymi <br>na Platformie B2B będzie ona niedostępna w dniach:</p>
          <p>01. lipiec 2025 w godzinach 0:00 do 5:00</p>
          <p>04. lipiec 2025 w godzinach 10:00 do 14:00</p>
          <p>W tym czasie prosimy o składanie zamówień drogą mailową lub telefonicznie.</p>
          <p>Za utrudnienia przepraszamy</p>
        </div>
        -->

        <h3 class="form-title form-title--old">DLA STAŁYCH KLIENTÓW</h3>
        <div class="main-page-wrapper">
          <SingInPage class="main-panel-sign-in" />
        </div>
      </div>

      <div class="new-clients">
        <h3 class="form-title form-title--new">DLA NOWYCH KLIENTÓW</h3>
        <BeforeLoginContact />
      </div>
      <!-- </BannerOpacity> -->
    </div>
  </div>

  <!-- <Page class="main-page-template" type="MAINPAGE" /> -->
  <!-- <ContactForm /> -->
</template>

<script>
import {
  SingInPage,
  BannerOpacity,
  Page,
  ContactForm
} from "../RedbayComponents";
import BeforeLoginContact from "./VetDirectBeforeLoginContact";

export default {
  components: {
    SingInPage,
    BannerOpacity,
    Page,
    ContactForm,
    BeforeLoginContact
  },
  beforeMount() {
    if (this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "welcomePage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/MainPage.vue